import * as yup from "yup";

import * as RHFPhoneValidationRules from "@/utils/validation/schemas/phone.RHF";

export const OptionalPhoneSchema = yup.object({
    phone: RHFPhoneValidationRules.optionalPhone,
    phonePrefix: RHFPhoneValidationRules.phonePrefix
});

export const RequiredPhoneSchema = yup.object({
    phone: RHFPhoneValidationRules.phone,
    phonePrefix: RHFPhoneValidationRules.phonePrefix
});

export type OptionalPhoneFormValues = yup.InferType<typeof OptionalPhoneSchema>;
export type RequiredPhoneFormValues = yup.InferType<typeof RequiredPhoneSchema>;

export type PhoneFieldValues =
    | OptionalPhoneFormValues
    | RequiredPhoneFormValues;
